'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dTarget from "./io.intela.sites.intelacloud.content.-Target.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Target$External(url) {
  this.i7 = null;
  this.i7 = url;
}
export { $c_Lio_intela_sites_intelacloud_content_Target$External as $c_Lio_intela_sites_intelacloud_content_Target$External };
$p = $c_Lio_intela_sites_intelacloud_content_Target$External.prototype = new $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dTarget.$h_Lio_intela_sites_intelacloud_content_Target();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Target$External;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Target$External() {
}
export { $h_Lio_intela_sites_intelacloud_content_Target$External as $h_Lio_intela_sites_intelacloud_content_Target$External };
$h_Lio_intela_sites_intelacloud_content_Target$External.prototype = $p;
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-1495891713), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Target$External) && (this.i7 === x$0.i7)));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "External";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.i7;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Target$External(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bI)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Target$External as $isArrayOf_Lio_intela_sites_intelacloud_content_Target$External };
var $d_Lio_intela_sites_intelacloud_content_Target$External = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Target$External, "io.intela.sites.intelacloud.content.Target$External", ({
  bI: 1,
  aI: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Target$External as $d_Lio_intela_sites_intelacloud_content_Target$External };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Target$-External.js.map
